module.exports = require('./lib/index.js');



//////////////////
// WEBPACK FOOTER
// ./~/react-csv/index.js
// module id = 566
// module chunks = 0